// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DisplayTitle_wrapper__Q5dlp","headings":"DisplayTitle_headings__DUQnQ","small":"DisplayTitle_small__lBXoY"};